import React from 'react';
import FormulaFieldProto from '../formula-proto';

export default function renderFormulaInList(id, props) {
    return <FormulaFieldProto renderMode="list" id={id} {...props} />;
}